import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { CONTRACT_PLACEHOLDER_FIELDS } from "../../utils/placeholderAutofill";
import type { PlaceholderOption } from "./CreatePlaceholderModal";

/**
 * The suggestions for "Add New Placeholder" in wording that ends up in a contract (contract templates, library
 * clauses): the fields the contract wizard fills in by itself. Pass them with `allowCustomPlaceholders`, since
 * any other name the author types is still a valid placeholder, filled in by hand.
 */
export function useContractPlaceholderOptions(): PlaceholderOption[] {
  const { t } = useTranslation("contractTemplates");
  return useMemo(
    () =>
      CONTRACT_PLACEHOLDER_FIELDS.map((f) => ({
        value: f.key,
        label: t(`placeholderFields.${f.key}`, { defaultValue: f.label }),
        hint: f.example,
      })),
    [t],
  );
}
